export const groupsAllUnitsTableNativeId = "groups-all-units-table";
